import { MouseEvent as ReactMouseEvent } from "react";

import { TableColumn } from "@/components/Table/Table";
import { Tooltip } from "@/components/Tooltip/Tooltip";

import { SortParams } from "@/types/types";
import { prospectJobTitle } from "@/utils/prospectJobTitle";

import { ListPerson } from "../../schema/list";
import { getOrderStatus } from "../column-utils";

/**
 * The lead list's "Title" column. Extracted from `allColumns.tsx` to keep that file under the
 * file-length ratchet.
 *
 * It renders — and sorts on — `prospect.title`, the same field every lead detail view shows. It
 * used to display the normalized `job_title_to_seniority.jobTitle` instead, so a person whose two
 * title fields had drifted apart appeared to hold a different role in the list than in their own
 * detail panel (PREC-3804).
 */
export const renderTitleColumn = (
	ts: (key: string) => string,
	handleCopyClick: (value: string) => void,
	sortingInbox: SortParams
): TableColumn => {
	const orderTitle = "prospect.title";

	return {
		title: ts("title"),
		width: "fit-content",
		orderTitle,
		orderStatus: getOrderStatus(sortingInbox, orderTitle),
		uid: "title",
		hideable: true,
		moveable: true,
		show: true,
		render: (row: ListPerson) => {
			const title = prospectJobTitle(row.prospect);

			return (
				<div>
					<Tooltip content={title}>
						<button
							className="text-ellipsis overflow-hidden max-w-[250px] cursor-pointer"
							onClick={(e: ReactMouseEvent) => {
								e.preventDefault();
								e.stopPropagation();
								handleCopyClick(title);
							}}
						>
							{title}
						</button>
					</Tooltip>
				</div>
			);
		},
	};
};
